import { AxiosResponse } from "axios";

import {
  ICandidaturaArquivoForm,
  ICandidaturaDeleteArquivoProps,
  ICandidaturaDTO,
  ICandidaturaFormProps,
  ICandidaturaResumidaDTO,
} from "../../types/candidatura";
import { removeEmpty } from "../../utils/removeEmpty";
import { ApiPesquisaSatisfacao } from "../../Apis/PesquisaSatisfacao";

const basePath = "/candidatura";

export class Candidatura {
  static async post(): Promise<AxiosResponse<ICandidaturaResumidaDTO>> {
    return ApiPesquisaSatisfacao.post(`${basePath}`);
  }

  static async put(
    props: ICandidaturaFormProps
  ): Promise<AxiosResponse<ICandidaturaDTO>> {
    const { uuid, ...rest } = props;
    const data = removeEmpty(rest);
    return ApiPesquisaSatisfacao.put(`${basePath}/${uuid}`, data);
  }

  static async anexar_arquivo(
    props: ICandidaturaArquivoForm
  ): Promise<AxiosResponse<ICandidaturaDTO>> {
    const { uuid, file } = props;

    const formData = new FormData();
    formData.append("file", file);

    return ApiPesquisaSatisfacao.post(
      `${basePath}/${uuid}/anexar-arquivo`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }

  static async deletar_arquivo(
    props: ICandidaturaDeleteArquivoProps
  ): Promise<AxiosResponse<ICandidaturaDTO>> {
    const { uuid, uuidArquivo } = props;

    return ApiPesquisaSatisfacao.delete(
      `${basePath}/${uuid}/desvincular-arquivo/${uuidArquivo}`
    );
  }
}
